import { all, takeEvery, takeLatest } from 'redux-saga/effects';
import { API } from 'src/services';

/* ------------- Types ------------- */
import { authTypes } from 'src/redux/authRedux';
import { themeTypes } from 'src/redux/themeRedux';
import { usersTypes } from 'src/redux/usersRedux';
import { contentTypes } from 'src/redux/contentRedux';
import { reportTypes } from 'src/redux/reportRedux';
import { quarantineTypes } from 'src/redux/quarantineRedux';
import { testingTypes } from 'src/redux/testRedux';
import { depositionTypes } from 'src/redux/depositionRedux';
import { filesTypes } from 'src/redux/fileRedux';

/* ------------- Sagas ------------- */
import authSaga from './authSaga';
import themeSaga from './themeSaga';
import usersSaga from './usersSaga';
import contentSaga from './contentSaga';
import reportSaga from './reportSaga';
import quarantineSaga from './quarantineSaga';
import testingSaga from './testSaga';
import depositionSaga from './depositionSaga';
import scheduleDepositionSaga from './scheduleDepositionSaga';
import fileSaga from './fileSaga';
import { scheduleDepositionTypes } from 'src/redux/scheduleDepositionRedux/types';

/* ------------- API ------------- */
const api = API.create();

/* ------------- Connect Types To Sagas ------------- */

export default function* root() {
  yield all([
    takeLatest(authTypes.SIGN_IN, authSaga.signIn, api.signIn),
    takeLatest(authTypes.SIGN_OUT, authSaga.signOut, api.signOut),
    takeLatest(authTypes.EXCHANGE_TOKEN, authSaga.exchangeToken, api.exchangeToken),
    takeLatest(authTypes.GET_PERMISSION, authSaga.getPermission, api.getPermission),
    takeLatest(usersTypes.GET_CURRENT_PROFILE, usersSaga.getCurrentProfile, api.getCurrentProfile),
    takeLatest(authTypes.CHANGE_PASSWORD, authSaga.changePassword, api.changePassword),

    takeLatest(usersTypes.GET_USERS, usersSaga.getUsers, api.getUsers),
    takeLatest(usersTypes.GET_USER_BY_ID, usersSaga.getUserById, api.getUserById),
    takeLatest(usersTypes.CREATE_USER, usersSaga.createUser, api.createUser),
    takeLatest(usersTypes.UPDATE_USER, usersSaga.updateUser, api.updateUser),
    takeLatest(usersTypes.DELETE_USER, usersSaga.deleteUserById, api.deleteUser),

    takeLatest(themeTypes.GET_THEMES, themeSaga.getTenants, api.getTenants),

    takeLatest(contentTypes.GET_USER_ROLES, contentSaga.getUserRoles, api.getUserRole),

    takeLatest(reportTypes.GET_REPORTS, reportSaga.getReports, api.getReports),
    takeLatest(
      reportTypes.GET_USER_HEALTH_REPORT_BY_ID,
      reportSaga.getUserHealthReportById,
      api.getUserHealthReportById,
    ),
    takeLatest(
      reportTypes.GET_USER_LOCATION_REPORT_BY_ID,
      reportSaga.getUserLocationReportById,
      api.getUserLocationReportById,
    ),
    takeLatest(
      reportTypes.GET_USER_CONTACT_REPORT_BY_ID,
      reportSaga.getUserContactReportById,
      api.getUserContactReportById,
    ),

    takeLatest(quarantineTypes.GET_QUARANTINES, quarantineSaga.getQuarantines, api.getQuarantines),
    takeLatest(
      quarantineTypes.GET_USER_HEALTH_QUARANTINE_BY_ID,
      quarantineSaga.getUserHealthQuarantineById,
      api.getUserHealthQuarantineById,
    ),
    takeLatest(
      quarantineTypes.GET_USER_LOCATION_QUARANTINE_BY_ID,
      quarantineSaga.getUserLocationQuarantineById,
      api.getUserLocationQuarantineById,
    ),
    takeLatest(
      quarantineTypes.GET_USER_CONTACT_QUARANTINE_BY_ID,
      quarantineSaga.getUserContactQuarantineById,
      api.getUserContactQuarantineById,
    ),

    takeLatest(testingTypes.GET_TEST_REGISTRATIONS, testingSaga.getTestRegistrations, api.getTestRegistrations),
    takeLatest(testingTypes.GET_TEST_RESULTS, testingSaga.getTestResults, api.getTestResults),
    takeLatest(testingTypes.GET_TEST_DETAIL_INFO, testingSaga.getTestDetailInfo, api.getTestDetailInfo),

    takeLatest(depositionTypes.GET_DEPOSITIONS, depositionSaga.getDepositions, api.getDepositions),
    takeLatest(depositionTypes.GET_DEPOSITION_BY_ID, depositionSaga.getDepositionById, api.getDepositionById),
    takeLatest(depositionTypes.CREATE_DEPOSITION, depositionSaga.createDeposition, api.createDeposition),
    takeLatest(depositionTypes.UPDATE_DEPOSITION, depositionSaga.updateDeposition, api.updateDeposition),
    takeLatest(depositionTypes.DELETE_DEPOSITION, depositionSaga.deleteDeposition, api.deleteDeposition),
    takeLatest(depositionTypes.APPROVE_DEPOSITION, depositionSaga.approveDeposition, api.approveDeposition),
    takeLatest(depositionTypes.REJECT_DEPOSITION, depositionSaga.rejectDeposition, api.rejectDeposition),
    takeLatest(depositionTypes.LOCK_DEPOSITION, depositionSaga.lockDeposition, api.lockDeposition),

    takeLatest(depositionTypes.RENAME_FILE, depositionSaga.renameFile, api.renameFile),
    takeLatest(depositionTypes.DELETE_FILE, depositionSaga.deleteFile, api.deleteFile),
    takeLatest(
      depositionTypes.GRANT_ACCESS_FINAL_DEPOSITION,
      depositionSaga.grantAccessFinalDeposition,
      api.grantAccessFinalDeposition,
    ),

    takeLatest(
      depositionTypes.GET_DEPOSITION_EXHIBIT_FILES,
      depositionSaga.getDepositionExhibitFiles,
      api.getDepositionFiles,
    ),
    takeEvery(
      depositionTypes.GET_DEPOSITION_FINAL_FILES,
      depositionSaga.getDepositionFinalFiles,
      api.getDepositionFiles,
    ),
    takeLatest(
      depositionTypes.GET_DEPOSITION_PRODUCTION_FILES,
      depositionSaga.getDepositionProductionFiles,
      api.getDepositionFiles,
    ),
    takeLatest(
      depositionTypes.GET_DEPOSITION_REQUESTER,
      depositionSaga.getDepositionRequester,
      api.getDepositionRequester,
    ),
    takeEvery(
      depositionTypes.GET_DEPOSITION_INVOLED_PARTIES,
      depositionSaga.getDepositionInvoledParties,
      api.getDepositionInvoledParties,
    ),
    takeLatest(depositionTypes.COMPLETE_DEPOSITION, depositionSaga.completeDeposition, api.completeDeposition),
    takeLatest(filesTypes.GET_EXHIBIT_UPLOAD_URL, fileSaga.getExhibitUploadUrl, api.getExhibitUploadUrl),
    takeLatest(filesTypes.GET_FINAL_UPLOAD_URL, fileSaga.getFinalUploadUrl, api.getFinalUploadUrl),
    takeLatest(filesTypes.GET_PRODUCTION_UPLOAD_URL, fileSaga.getProductionUploadUrl, api.getProductionUploadUrl),
    takeLatest(filesTypes.PRE_EXHIBIT_UPLOAD, fileSaga.preExhibitUpload, api.preExhibitUpload),
    takeLatest(filesTypes.PRE_FINAL_UPLOAD, fileSaga.preFinalUpload, api.preFinalUpload),
    takeLatest(filesTypes.PRE_PRODUCTION_UPLOAD, fileSaga.preProductionUpload, api.preProductionUpload),
    takeEvery(filesTypes.UPLOAD_FILES, fileSaga.uploadFiles, api),
    takeLatest(filesTypes.DOWNLOAD_FILES, fileSaga.downloadFiles, api),
    takeEvery(filesTypes.PREPRARE_DOWNLOAD, fileSaga.prepareDownload, api.prepareDownload),

    // Schedule Deposition
    takeLatest(
      scheduleDepositionTypes.GET_SCHEDULE_DEPOSITIONS,
      scheduleDepositionSaga.getScheduleDepositions,
      api.getScheduleDepositions,
    ),
    takeLatest(
      scheduleDepositionTypes.UPDATE_SCHEDULE_DEPOSITION,
      scheduleDepositionSaga.updateScheduleDeposition,
      api.updateScheduleDeposition,
    ),

    // some sagas only receive an action
    // takeLatest(StartupTypes.STARTUP, startup),
    // Language
  ]);
}
